import { useAuthContext } from 'contexts/AuthContext';
import { FEATURE_FLAGS_DEFAULTS } from 'featureFlagsDefaults';
import { useQuery } from 'react-query';
import {
	FeatureFlagId,
	IReqFeatureFlags,
	IResFeatureFlags,
	IServerFeatureFlags
} from 'types/featureflags';
import { getEnv } from 'utils/api';
import { post } from './api';
import { API_ROUTES } from './apiRoutes';
import QueryKeys from './queryKeys';

const getServerFeatureFlags = async (): Promise<IServerFeatureFlags> => {
	const requestBody: IReqFeatureFlags = {
		features: Object.values(FEATURE_FLAGS_DEFAULTS).map((flag) => ({
			flag: flag.id,
			defaultVal: flag.env[getEnv()] ?? false
		}))
	};

	const res = await post<IReqFeatureFlags, IResFeatureFlags>(
		API_ROUTES.featureFlags,
		requestBody
	);

	const features = {} as IServerFeatureFlags['features'];

	for (const flagId of Object.values(FeatureFlagId)) {
		// we need to preserve null/undefined values from server response
		features[flagId] = res.data.features[flagId];
	}

	return { features };
};

export const useServerFeatureFlags = () => {
	const { authRes } = useAuthContext();

	return useQuery({
		queryKey: QueryKeys.featureFlags,
		queryFn: getServerFeatureFlags,
		enabled: authRes.verified
	});
};
